import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2225ed1a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../gim-wms/gim-wms-backend-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2225ed1a",
  null
  
)

export default component.exports